import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    state: 1,
    errorNricValid: '',
    token: '',
    refreshToken: '',
};

const checkNRICSessionReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.CHECK_NRIC_SESSION_SUCCESS:
            return updateObject(state, {
                state: 2,
                errorNricValid: '',
                ...payload,
            });
        case actionTypes.CHECK_NRIC_SESSION_FAILED:
            return updateObject(state, {
                state: 1,
                ...payload,
            });
        default: {
            return state;
        }
    }
};

export default checkNRICSessionReducer;
